import el from "@cypherpotato/el";
import { joinObjects, roundDecimals } from './../util';
import { Badge } from "./badge";
import { Icon } from "./icon";
import { Section } from "./layout";

export function FormControl(label, ...children) {
    return el(".form-control",
        label && el("label", label),
        ...children
    );
}

export function Select({ value, items, itemsRaw = null, ...props }) {
    return el("select.app-input[form-slot]",
        {
            ...props
        },
        items?.map(i => el("option", { value: i.value, selected: i.value == value }, i.text || i.label || i.value)),
        itemsRaw
    )
}

export function TextInput(name, placeholder, ...args) {
    return el("input.app-input[form-slot][type=text]", {
        name,
        id: name,
        placeholder
    }, ...args);
}

export function TextArea(name, value, ...args) {
    return el("textarea.app-input[form-slot]", value, {
        name,
        id: name
    }, ...args);
}

export function Checkbox(name, label, ...args) {
    const checkboxId = Math.random();
    return el(".checkbox-wrapper",
        el("input[form-slot][type=checkbox]", {
            name,
            id: checkboxId,
            style: {
                display: joinObjects(...args).hideCheckMark ? "none" : "block"
            }
        }, ...args),
        label && el("label", { for: checkboxId }, label)
    );
}

export function TagsInput(name, ...args) {
    const argsObj = joinObjects(...args);
    const tags = el.state.create(argsObj?.value || []);
    const onChange = argsObj?.onChange || null;

    tags.subscribe(value => {
        if (onChange) {
            onChange(value);
        }
    });

    return el("div.tags-input[form-slot=1]",
        Section(
            TextInput(null, "Separate values with commas", {
                onKeyDown(event) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        event.stopPropagation();

                        const value = event.target.value;
                        if (value.length > 0) {
                            tags.value.push(value);
                            tags.requestUpdate();
                            event.target.value = "";
                        }
                    }
                }
            })
        ),
        el.state.listening([tags], () =>
            Section(
                tags.value?.length && el(".tags.badge-list",
                    tags.value.map(tag =>
                        Badge(tag, null,
                            Icon("close-line", {
                                onClick() {
                                    tags.value = tags.value.filter(t => t !== tag);
                                    tags.requestUpdate();
                                }
                            })
                        )
                    )
                ) || null
            ),
        ),
        {
            id: name,
            name,
            $properties: {
                value: {
                    get() {
                        return tags.value;
                    },
                    set(value) {
                        tags.value = value;
                    }
                },
                length: {
                    get() {
                        return tags.value.length;
                    }
                }
            }
        }
    );
}

export function NumberInput({ value, step = 1, min = 0, max = 100, onChange = null }) {

    const decimalCount = step.countDecimals();
    const number = el.state.create(value || min);

    number.subscribe(value => {
        if (onChange) {
            onChange(value);
        }
    });

    function valueParsed() {
        var v = roundDecimals(Math.min(Math.max(number.value, min), max), decimalCount);
        if (v == number.value) {
            return v;
        }
        number.value = v;
        return v;
    }

    return el.state.listening([number], () =>
        el(".number-input-wrapper",
            {
                $properties: {
                    value: {
                        get() {
                            return number.value;
                        },
                        set(value) {
                            number.value = value;
                        }
                    }
                }
            },
            Icon("subtract-line", {
                onClick() {
                    if (number.value > min) {
                        number.value = number.value - step;
                    }
                }
            }),
            el("input.app-input[type=number]", {
                value: valueParsed(),
                onBlur(event) {
                    number.value = decimalCount == 0 ? parseInt(event.target.value) : parseFloat(event.target.value.replace(",", "."));
                }
            }),
            Icon("add-line", {
                onClick() {
                    if (number.value < max) {
                        number.value = number.value + step;
                    }
                }
            })
        )
    );
}